<template>
  <g ref="el" @mouseenter="mouseEnter" @mouseleave="mouseLeave" @mousedown="mouseDown" @mouseup="mouseUp" >
    <slot></slot>
  </g>
</template>

<script>
import Vue from 'vue'
import '../style/popover.css'
import popover from '../mixins/popover.js'

let uid = 0

export default {
  props: {
    content: {
      type: [String, Object],
      required: true
    },
    delay: {
      type: Number,
      default: 1000
    },
    hideDelay: {
      type: Number,
      default: 500
    },
    data: {
      default: null
    },
    position: {
      type: String,
      default: 'top'
    }
  },
  data () {
    return {
      contentVm: null,
      contentDiv: null,
      showPopover: false,
      popTimeout: null,
      preventPop: false,
      id: null
    }
  },
  watch: {
    position () {
      if (this.contentVm) {
        this.contentVm._props.position = this.position
      }
    }
  },
  beforeDestroy () {
    if (this.contentVm !== null) {
      this.contentVm.$destroy()
      this.contentVm.$el.parentElement.removeChild(this.contentVm.$el)
      this.contentVm = null
    }
  },
  methods: {
    mouseEnter () {
      clearTimeout(this.popTimeout)
      this.popTimeout = setTimeout(this.show, this.delay)
    },
    mouseLeave () {
      clearTimeout(this.popTimeout)
      this.popTimeout = setTimeout(this.hide, this.hideDelay)
      if (this.contentVm) {
        this.contentVm.captureEvents = true
      }
    },
    mouseDown () {
      clearTimeout(this.popTimeout)
      this.preventPop = true
    },
    mouseUp () {
      this.preventPop = false
    },
    show () {
      if (!this.preventPop) {
        if (this.contentVm === null) {          
          this.id = uid++
          this.contentDiv = document.createElement('div')
          this.contentDiv.setAttribute('id', 'd3vue-popover-' + this.id)
          document.getElementsByTagName('body')[0].appendChild(this.contentDiv)
          const parent = this
          this.contentVm = new Vue({
            el: '#d3vue-popover-' + this.id,
            mixins: [
              popover
            ],
            computed: {
              show () {
                return parent.showPopover || this.showPopover
              },
              text () {
                return typeof parent.content === 'string' ? parent.content : false
              },
              component () {
                return parent.content
              },
              data () {
                return parent.data
              }
            },
            created () {
              this.id = parent.id
              this.$nextTick(() => {
                this.parent = parent.$refs.el
              })
            },
            methods: {
              mouseEnter () {
                clearTimeout(this.popTimeout)
                this.showPopover = parent.showPopover
              },
              mouseLeave () {
                this.popTimeout = setTimeout(() => {
                  this.showPopover = false
                }, parent.hideDelay)
              }
            }
          })          
          this.contentVm._props.position = this.position
        }
        this.showPopover = true
      }
    },
    hide () {      
      this.showPopover = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/Popover.vue